[
  "@126.com",
  "@163.com",
  "@aol.com",
  "@firemailbox.club",
  "@functionizeapp.com",
  "@gamil.com",
  "@gmail.com",
  "@gmx.com",
  "@gmx.net",
  "@hotmail.com",
  "@icloud.com",
  "@inbox.com",
  "@mail.com",
  "@mail.ru",
  "@maileze.net",
  "@mailinator.com",
  "@mailinator.net",
  "@outlook.com",
  "@outloo.com",
  "@protonmail.com",
  "@qq.com",
  "@roidna.com",
  "@sina.com",
  "@vomoto.com",
  "@yahoo.com",
  "@yandex.com",
  "@yopmail.com",
  "@zoho.com",
  "victorops",
  "@gail.com",
  "@example.com",
  "@email.tst",
  "testing@example.com",
  "@proton.me",
  "@pm.me",
  "@imagepoet.net",
  "@oastify.com",
  ".oastify.com"
]
